import { render, staticRenderFns } from "./SubscribeForm.vue?vue&type=template&id=521a12be&scoped=true&"
import script from "./SubscribeForm.vue?vue&type=script&scoped=true&lang=js&"
export * from "./SubscribeForm.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./SubscribeForm.vue?vue&type=style&index=0&id=521a12be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521a12be",
  null
  
)

export default component.exports